// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__MI-gT","alertIcon":"ConfirmModal_alertIcon__2Jpi4"};